<button
  ngbDropdownItem
  *ngIf="!preparedActionData?.children"
  [name]="preparedActionData.name"
  class="m-0"
  (click)="onActionClicked(preparedActionData.name, rowData)"
  placement="top"
>
  <i [class]="preparedActionData.icon"></i>
  {{ preparedActionData.name | translate }}
</button>

<span >
  <button placement="end-top" *ngIf="preparedActionData?.children" ngbDropdown class="dropdown-item-class m-0">
    <span ngbDropdownToggle id="option-children" aria-expanded="false" class="p-0">
      <i [class]="preparedActionData.icon"></i>
      {{ preparedActionData.name | translate }}
    </span>
    <span ngbDropdownMenu aria-labelledby="option-children">
      <a
        ngbDropdownItem
        class="py-2"
        *ngFor="let child of preparedActionData?.children"
        (click)="onActionClicked(child.name, rowData)"
      >
        <i [class]="child?.icon"></i>
        {{ child.name | translate }}
      </a>
    </span>
  </button>
</span>
